var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchImgAndVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5005_75605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2062 22.2062L32 27.0518L28.1252 28.9891L26.1893 32.8625L21.2062 22.2076V22.2062ZM29.371 12.3832V15.1525H27.9877V12.3832H25.2199V11H29.3724V12.3832H29.371ZM11.3832 28.9877H14.1525V30.371H10V26.2199H11.3832V28.9877ZM11.3832 12.3832V15.1525H10V11H14.1511V12.3832H11.3832ZM16.9176 12.3832H22.4534V11H16.9163V12.3832H16.9176ZM16.9176 30.371H22.4534V28.9877H16.9163V30.371H16.9176ZM10 23.4534H11.3832V17.9163H10V23.452V23.4534ZM27.9877 23.4534H29.371V17.9163H27.9877V23.452V23.4534Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5005_75605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchImgAndVideo);
export default __webpack_public_path__ + "static/media/switch-img-and-video.cf7d4697a8882c8a27a3c8f5a491d042.svg";
export { ForwardRef as ReactComponent };